/** Application branding — single source of truth for UI copy. */
import companyLogoUrl from "@/assets/company-logo.png";

export const APP_NAME = "NAK Roofing System";
export const APP_TAGLINE = "Transform | Build | Scale";
/** Public logo (works with Vite `base` in production). */
export const APP_LOGO = `${import.meta.env.BASE_URL}logo.png`;
export const DEFAULT_COMPANY_NAME = APP_NAME;

/**
 * Company letterhead logo printed at the top-left of every generated PDF
 * (Nak Roofing System). Imported as a bundled Vite asset so it resolves to a
 * hashed, same-origin URL — this is captured reliably by html2canvas (see
 * web/src/lib/htmlPdf.ts) without the CORS / not-yet-loaded failures that
 * remote image URLs can hit.
 */
export const COMPANY_PDF_LOGO = companyLogoUrl;
